import { createContext, useContext, useRef, useState } from "react"

const Context = createContext()

export function Form({ children, onSubmit, ...props }) {
    const ref = useRef()
    const [submissions, setSubmissions] = useState(0)
    const submit = e => {
        setSubmissions(submissions + 1)
        e.preventDefault()
        if (ref.current.checkValidity()) onSubmit?.()
    }
    return <form {...props} ref={ref} onSubmit={submit} noValidate>
        <Context.Provider value={submissions}>
            {children}
        </Context.Provider>
        <div className="h-0 w-0 overflow-hidden">
            <input type="submit" tabIndex={-1} />
        </div>
    </form>
}

export const useFormSubmissions = () => useContext(Context)